"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getRequestStatusMessage = exports.RequestType = exports.RequestStatus = void 0;
var RequestStatus;
(function (RequestStatus) {
    RequestStatus["Created"] = "created";
    RequestStatus["AwaitingApproval"] = "awaiting approval";
    RequestStatus["InProgress"] = "in progress";
    RequestStatus["AwaitingAcceptance"] = "awaiting acceptance";
    RequestStatus["Completed"] = "completed";
    RequestStatus["Declined"] = "declined";
})(RequestStatus = exports.RequestStatus || (exports.RequestStatus = {}));
var RequestType;
(function (RequestType) {
    RequestType["Breakdown"] = "breakdown";
    RequestType["CorrectiveMaintenance"] = "corrective maintenance";
    RequestType["PreventativeMaintenance"] = "preventative maintenance";
})(RequestType = exports.RequestType || (exports.RequestType = {}));
const getRequestStatusMessage = (status) => {
    const statusMap = {
        [RequestStatus.Created]: 'Reequest Created',
        [RequestStatus.AwaitingApproval]: 'Awaiting Tenderd Approval',
        [RequestStatus.InProgress]: 'In Progress',
        [RequestStatus.AwaitingAcceptance]: 'Awaiting Acceptance',
        [RequestStatus.Completed]: 'Completed',
        [RequestStatus.Declined]: 'Cancelled'
    };
    return statusMap[status] || '';
};
exports.getRequestStatusMessage = getRequestStatusMessage;
//# sourceMappingURL=request.js.map